export const version = '2.88.0' // bump-client-version 2026-06-05T11:55:09.117Z
